import { render, staticRenderFns } from "./IndirectLedger.vue?vue&type=template&id=29ca16bc"
import script from "./IndirectLedger.vue?vue&type=script&lang=js"
export * from "./IndirectLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports